import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import {
	server
} from '../../providers/http-service'
// import util from '../../utils/util.js'
Vue.use(VueAxios, axios)
const state = {
	result: '',
	hosId: '',
	parentHosId: ''
}
const actions = {
	getDefaultHosId({
		commit
	}, params) {
		server.getDefaultHosId(params).then(res => {
			commit('setDefaultHosId', res)
		})
	}


}
const mutations = {
	setDefaultHosId(state, res) {
		state.result = res.result;
		state.hosId = res.hosId;
		state.parentHosId = res.parentHosId;
	}
}
export default {
	state,
	actions,
	mutations
}
